import PropTypes from "prop-types";
import Dropdown from "@shared/v2/Dropdown/Dropdown";
import { CustomOption } from "../../../Settings/Phone/CallRecordingDropdown";
import { INBOUND_RECORDING_OPTIONS } from "../../../Settings/Phone/helpers/recordingOptions";
import { inboundRecordingNotificationOptions } from "../../../Settings/Phone/helpers/recordingNotificationOptions";
import PlayMessage from "../../../Settings/Phone/PlayMessage";
import NoticeTwoPartyConsent from "../../../Settings/Phone/NoticeTwoPartyConsent";
import { useCurrentUser } from "../../../reducers/layoutReducer/selectors";

const CallRecording = ({
  inboundRecording,
  setInboundNotificationMessageCondition,
  setInboundRecording,
  inboundNotificationMessageCondition,
  showTwoPartyNotice,
  agreeTwoParty,
  setAgreeTwoParty,
}) => {
  const currentUser = useCurrentUser();
  return (
    <div>
      <div className="tw-text-18px tw-text-gray-75 tw-font-normal tw-pb-[14px]">Call Recording</div>

      <div className="!tw-grid tw-grid-cols-2 tw-gap-[40px] tw-justify-between tw-pb-[16px]">
        <Dropdown
          label="Inbound Recording"
          components={{ Option: CustomOption }}
          options={INBOUND_RECORDING_OPTIONS}
          value={INBOUND_RECORDING_OPTIONS.find((o) => o.value === inboundRecording)}
          name="inboundRecording"
          menuShouldComeToFront
          onChange={(option) => setInboundRecording(option.value)}
        />
        {inboundRecording !== "disabled" ? (
          <Dropdown
            label="Notification Message"
            components={{ Option: CustomOption }}
            options={inboundRecordingNotificationOptions(
              currentUser.account.isPlace,
              currentUser.account.twoPartyState,
            )}
            value={inboundRecordingNotificationOptions(
              currentUser.account.isPlace,
              currentUser.account.twoPartyState,
            ).find((o) => o.value === inboundNotificationMessageCondition)}
            name="inboundNotificationMessageCondition"
            menuShouldComeToFront
            onChange={(option) => setInboundNotificationMessageCondition(option.value)}
            toolTipPlacement="top"
            toolTipInfoContent={
              <div className="tw-text-left tw-text-14d tw-w-[217px]">
                Audio notification message must always play for businesses operating in states that require
                2-party consent to record phone calls.
              </div>
            }
          />
        ) : (
          <div />
        )}
      </div>
      <div className="tw-grid tw-grid-cols-2 tw-gap-[40px] tw-justify-between tw-pb-[16px]">
        <div />
        {inboundRecording !== "disabled" ? <PlayMessage /> : <div />}
      </div>
      <NoticeTwoPartyConsent
        showTwoPartyNotice={showTwoPartyNotice}
        agreeTwoParty={agreeTwoParty}
        setAgreeTwoParty={setAgreeTwoParty}
      />
    </div>
  );
};

CallRecording.propTypes = {
  setInboundNotificationMessageCondition: PropTypes.func,
  setInboundRecording: PropTypes.func,
  inboundRecording: PropTypes.string,
  inboundNotificationMessageCondition: PropTypes.string,
  setAgreeTwoParty: PropTypes.func,
  showTwoPartyNotice: PropTypes.bool,
  agreeTwoParty: PropTypes.bool,
};

CallRecording.defaultProps = {
  inboundRecording: "disabled",
  inboundNotificationMessageCondition: "always",
  setInboundNotificationMessageCondition: () => {},
  setInboundRecording: () => {},
  showTwoPartyNotice: false,
  agreeTwoParty: false,
  setAgreeTwoParty: () => {},
};
export default CallRecording;
